"use strict";import{css as r}from"@spectrum-web-components/base";const o=r`
:host{border:none;position:relative}:host([drop-target]){--mod-table-border-color:transparent;outline-color:var(
--highcontrast-table-focus-indicator-color,var(
--mod-table-drop-zone-outline-color,var(--spectrum-table-drop-zone-outline-color)
)
);outline-style:solid;outline-width:var(
--mod-table-focus-indicator-thickness,var(--spectrum-table-focus-indicator-thickness)
)}:host{display:table-row-group}:host{border-block:var(
--mod-table-border-width,var(--spectrum-table-border-width)
) solid var(
--highcontrast-table-border-color,var(--mod-table-border-color,var(--spectrum-table-border-color))
);border-inline:var(
--mod-table-outer-border-inline-width,var(--spectrum-table-outer-border-inline-width)
) solid var(
--highcontrast-table-border-color,var(--mod-table-border-color,var(--spectrum-table-border-color))
);border-radius:var(
--mod-table-border-radius,var(--spectrum-table-border-radius)
);display:block;flex-grow:1;overflow:auto}:host(:not([tabindex])){overflow:visible}
`;export default o;
//# sourceMappingURL=table-body.css.js.map
